import { API_URL } from '../../../constants';
import makeUrl from '../../utils/makeUrl';
import _fetch from '../../_fetch';

export default function fetchNdeByUuid(ndeUuid, options = {}) {
  return function withContext(context) {
    const url = makeUrl(API_URL, `ndes/uuid/${ndeUuid}`, options);

    const config = {
      method: 'GET',
      headers: {
        'Accept': 'application/json;charset=utf-8',
        'Content-Type': 'application/json;charset=utf-8'
      },
      ...options.reqConfig
    };

    return _fetch(url, {
      withAuth: false,
      ...options
    }, config)(context);
  };
}
